import src from "IMAGE";
export default { src, width: 2000, height: 600, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAI0lEQVR42m3KsQkAAAgDsIIn6BP6/38KbqUdsgVRsy89aGhyeo4T8WQ0zhsAAAAASUVORK5CYII="};
